<template>
<div class="w-full block border-t border-grey-25"/>
</template>

<script>
export default {
    name: "HorizontalSeparator"
}
</script>
